/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsGraphsDto } from '../../models/submissions-graphs-dto';

export interface FactorFilteredSubmissionsCustomerReportGet$Plain$Params {
  fromDate?: string;
  toDate?: string;
  clientNames?: Array<string>;
  aggregationType?: string;
  startHour?: string;
  endHour?: string;
}

export function factorFilteredSubmissionsCustomerReportGet$Plain(http: HttpClient, rootUrl: string, params?: FactorFilteredSubmissionsCustomerReportGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsGraphsDto>>> {
  const rb = new RequestBuilder(rootUrl, factorFilteredSubmissionsCustomerReportGet$Plain.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
    rb.query('clientNames', params.clientNames, {});
    rb.query('aggregationType', params.aggregationType, {});
    rb.query('startHour', params.startHour, {});
    rb.query('endHour', params.endHour, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsGraphsDto>>;
    })
  );
}

factorFilteredSubmissionsCustomerReportGet$Plain.PATH = '/Factor/filtered-submissions-customer-report';
